module.exports = __webpack_public_path__ + "img/3_1.45b99735.png";